/*******************************************************************************
TRIGER CHANGE TO CHECKBOX FILTER
Handles a click on a checkbox filter.
*******************************************************************************/

import updateCheckboxFilter from './update-filter';

export default function triggerCheckBoxFilterUpdate(e) {
    const checkboxName = $(e.currentTarget).data('name');
    updateCheckboxFilter(checkboxName);
}
